module.exports = __webpack_public_path__ + "img/package2.f4c41f01.png";